import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { fromJS, List, Map as ImMap } from 'immutable';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import { PropertyGroupTypes, saveProperty, saveProperties, selectLists, selectOriginalFavorites, selectLoading as selectPropertyLoading, selectProperty } from 'data/property';
import { selectUsageSection, selectProfile, selectPlanDetails } from '../../data/user/selectors';
import AddToGroup from 'app/components/AddToGroup';
import AddToMarketingListModal from 'app/components/AddToMarketingListModal';


import { deferExecutor, deferRegistrator } from 'app/DeferredOnLocation';
import Map from 'app/components/Map';
import Confirm from 'app/components/Confirm';
import { getPlanDetails, getUsageSectionAPI, getPlan, getPlansTypeAPI } from "data/user/actions";
import LeaveMessagePopup from '../AccountNew/modals/LeaveMessage';
import PurchaseSavesAndExportsPopup from "../AccountNew/modals/PurchaseSavesAndExports";

import {
  RESULTS_PER_PAGE,
  SearchModes,
  SearchOverlays,
  setLocation,
  setPage,
  setRange,
  toggleRange,
  toggleSelection,
  setSort,
  setLayout,
  setActiveContext,
  setOverlay,
  savedCountListings,
  searchListings,
  searchMapPins,
  searchProperty,
  searchStatistics,
  searchFavorites,
  searchLeadList,
  saveListings,
  clearStatistics,
  refreshSearch,
  selectLoading,
  selectStale,
  selectLocation,
  selectSuggestion,
  selectFilter,
  selectResult,
  selectActiveContext,
  selectStatistic,
  selectFavoriteSearchStale,
  selectFavoriteSearchLoading,
  clearAll,
  restorePreviousResult,
  savePreviousSearchState,
  clearPreviousSearchState
} from 'data/search';

import css from './style.scss';
import OverlayView from './Overlay';
import StatisticCharts from './Statistic';
import Results from './Results';
import PropertyView from './Property';
import Header from './Header';
import { getAppendJobEstimate } from '../../data/contacts/actions';
import SkipTraceModal from 'app/components/SkipTraceModal';
import { loadWalletList, getPrePaidCreditsSectionAPI } from '../../data/user';
import { selectAppendGroups, selectAppendJob } from '../../data/contacts';
import { selectresetPasswordSuccess } from '../../data/search';
import { searchPropertyContactsByPropertyID, searchPropertyContacts } from '../../data/property/actions';
import InfoAlert from '../components/InfoAlert';
import ActivateSubscriptionPopup from '../AccountNew/modals/ActivateSubscription';

import ToastNotification from '../components/ToastNotification';

class Search extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRange = this.handleChangeRange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSaveList = this.handleSaveList.bind(this);
    this.handleLayoutChange = this.handleLayoutChange.bind(this);
    this.handleOverlayChange = this.handleOverlayChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleDraw = this.handleDraw.bind(this);
    // this.handleRemoveBoundary = this.handleRemoveBoundary.bind(this);
    this.handleSaveProperty = this.handleSaveProperty.bind(this);
    this.handleBackFromProperty = this.handleBackFromProperty.bind(this);

    this.loadMarkerDetail = this.loadMarkerDetail.bind(this);
    this.buildSearchPayload = this.buildSearchPayload.bind(this);

    this.handleReset = this.handleReset.bind(this);
    this.hasShownToast = false;

    this.state = {
      activeMarker: null,
      tempRangeFrom: '',
      tempRangeTo: '',
      resultOffset: 1,
      resultLimit: 50,
      lazyLoadLimit: 50,
      fetchMore: false,
      waitingForApi: false,
      inputFlag: false,
      storedInputFlag: null,
      lazyDone: false,
      listingsReady: false,
      noMoreResults: false,
      skipDidUpdateOnce: false,
      resetChild: false,
      showToast: false,
      lastSearchFingerprint: null,
    };
  }

  resetListingState = () => {
    this.setState({ resultOffset: 1, fetchMore: false, tempRangeFrom: '', tempRangeTo: '', activeMarker: null });
  };


  triggerReset = () => {
    this.props.clearPreviousSearchState();
    this.setState({ resetChild: true, resultOffset: 1, fetchMore: false, tempRangeFrom: '', tempRangeTo: '', activeMarker: null, selectedPropertyId: null, lazyDone: false, noMoreResults: false });
  }

  buildSearchPayload = (resultOffset = 1, resultLimit = 50) => {
    const { location, filter, activeContext } = this.props;
    const l = (location.get('query') || ImMap()).toJS();
    let filt = filter.toJS();

    filt = Object.keys(filt).reduce((o, k) => ({
      ...o,
      [k]: moment.isMoment(filt[k]) ? filt[k].valueOf() : filt[k]
    }), {});

    const sortField = (activeContext?.get('sortField') || '').trim();

    return {
      ...l,
      ...filt,
      type: null,
      resultOffset,
      resultLimit,
      ...(sortField ? { sortField, sortAscending: activeContext.get('sortAscending') || false } : {})
    };
  };

  componentDidMount() {
    const { profile, getPlanDetails, getUsageSectionAPI, loadWalletList, getPrePaidCreditsSectionAPI, getPlansTypeAPI } = this.props;

    if (profile && profile.id) {
      getPlanDetails(profile.id);
      getUsageSectionAPI(profile.id);
      loadWalletList(profile.id);
      getPrePaidCreditsSectionAPI(profile.id);
      getPlansTypeAPI(profile.id);
    }

    if (this.props.redirectMessage && this.props.redirectMessage.trim() !== "") {
      this.setState({ showToast: true });
      setTimeout(() => {
        this.setState({ showToast: false });
      }, 5000);
    }
  }

  purchaseSavesAndExportsPopup = () => {
    const { purchaseSavesAndExportsPopup, usageSectionDetails } = this.props;
    purchaseSavesAndExportsPopup(usageSectionDetails);
  };

  componentDidUpdate(prevProps) {

    if (this.state.skipDidUpdateOnce) {
      this.setState({ skipDidUpdateOnce: false });
      return;
    }
    if (prevProps.rangeResetTick !== this.props.rangeResetTick) {
      this.setState({ tempRangeFrom: '', tempRangeTo: '', inputFlag: false, });
    }

    if (prevProps.activeContext && this.props.activeContext && prevProps.activeContext.get('rangeCount') !== this.props.activeContext.get('rangeCount')) {
      this.props.toggleSelection('all', false);
    }

    const { stale, loading, location, suggestion, filter, activeContext, savedCountListings, searchListings, searchMapPins, searchProperty, searchFavorites, searchLeadList, searchStatistics, statistic, favoriteStale, favoriteLoading, lazyDone, result } = this.props;
    if (!stale && (this.state.queriesSent || this.state.waitingForApi)) {
      this.setState({ queriesSent: false, waitingForApi: false });
    }
    if (!loading && location) {
      if (stale) {
        // this.resetListingState();
        this.setState({ listingsReady: false });
        const l = (location.get('query') || ImMap()).toJS();
        const { propertyId, streetAddress, fips } = l;
        let { apn } = l;
        const type = (suggestion.get('value') || ImMap()).get('type');

        let filt = filter.toJS();
        filt = Object.keys(filt).reduce((o, k) => ({ ...o, [k]: moment.isMoment(filt[k]) ? filt[k].valueOf() : filt[k] }), {});

        if (propertyId || (fips && apn) || location.get('mode') === SearchModes.Property || streetAddress) {
          // Strip weird characters from the APN, which can cause AWS to reject the request. E.g. "53-(A)- L109B" in property 1844922339 (which wasn't having its paraentheses escaped for some reason).
          if (apn) apn = apn.replace(/[^a-zA-Z0-9\s:-]/g, '');
          // For street searches, pass in search criteria so results may be filtered
          searchProperty({ ...(type === 'S' ? { ...filt } : {}), ...l, apn });
        } else {
          const ac = activeContext || ImMap();
          const sortField = (ac.get('sortField') || '').trim();
          const shapeDef = location.get('shapeDefinition');

          // const rangeTo = ac.get('rangeTo') != null ? Number(ac.get('rangeTo')) : (ac.get('resultCount') || 50);
          const rangeTo = ac.get('rangeTo') != null
            ? Number(ac.get('rangeTo'))
            : (ac.get('resultCount') || 50);
          const resultOffset = ac.get('resultOffset') != null ? Number(ac.get('resultOffset')) : 1;
          let difference = rangeTo - resultOffset;
          const resultLimit = difference < 50 ? difference + 1 : 50;
          this.setState({ resultOffset: resultOffset })
          const shapeDefinition = location.get('shapeDefinition');

          let baseParams;
          if (shapeDefinition) {
            // Only send shapeDefinition and other search params, exclude 'mode' and 'stale'
            const { mode, stale, ...rest } = location.toJS();
            baseParams = {
              ...rest,
              ...filt,
              type: null,
              shapeDefinition,
              resultOffset: ac.get('resultOffset') || 1,
              resultLimit: resultLimit,
              ...(sortField === '' ? {} : {
                sortField,
                sortAscending: ac.get('sortAscending') || false
              }),
            };
            delete baseParams.cityId;
          } else {
            baseParams = {
              ...l,
              ...filt,
              type: null,
              resultOffset: ac.get('resultOffset') || 1,
              resultLimit: resultLimit,
              ...(sortField === '' ? {} : {
                sortField,
                sortAscending: ac.get('sortAscending') || false
              }),
            };
          }

          // tell UI we're waiting
          if (!this.state.waitingForApi) this.setState({ waitingForApi: true });

          // fire both thunks; they MUST return a promise
          const p1 = searchListings(
            {
              ...baseParams,
              resultLimit: resultLimit || this.state.lazyLoadLimit,
              inputRange: ac.get('rangeEnabled'),
              startRange: ac.get('resultOffset'), endRange: ac.get('rangeTo'),
              ...(sortField ? { sortField, sortAscending: ac.get('sortAscending') || false } : {})
            },
            false
          );

          const p2 = searchMapPins(
            {
              ...baseParams,
              resultLimit: ac.get('rangeEnabled') ? Math.min(rangeTo ?? 250, 250) : 250,
              ...(sortField ? { sortField, sortAscending: ac.get('sortAscending') || false } : {})
            },
            false
          );

          Promise.all([p1, p2])
            .finally(() => {
              this.setState({ waitingForApi: false, queriesSent: true, listingsReady: true });
            });

          // Send correct params for shapeDefinition (exclude mode and stale)
          let favoritesParams;
          if (shapeDefinition) {
            const prevLocation = prevProps?.location;
            const prevShapeDef = prevLocation?.get('shapeDefinition');
            if (JSON.stringify(shapeDefinition) === JSON.stringify(prevShapeDef))
              return;
            const { mode, stale, label, query, geo, countryId, cityId, ...rest } = location.toJS();
            favoritesParams = { ...rest, shapeDefinition };
            searchFavorites(favoritesParams);
            searchLeadList(favoritesParams);
          }
        }
      } else {
        const l = (location.get('geo') || ImMap()).toJS();
        if (!favoriteLoading && favoriteStale) searchFavorites(l), searchLeadList(l);
        else if (!statistic.get('loading') && statistic.get('stale')) searchStatistics(l, statistic.get('filter').toJS());
      }


      if (prevProps.loading && !this.props.loading) {      // request finished
        const { selectedPropertyId, activeMarker } = this.state;

        // make sure we actually received results
        const hasResults =
          this.props.activeContext &&
          this.props.activeContext.get('resultCount') > 0;

        if (
          hasResults &&
          selectedPropertyId &&
          selectedPropertyId !== activeMarker
        ) {
          this.setState({ activeMarker: selectedPropertyId });
        }

      }

      const previewModal = document.getElementById('PostcardPreview');
      if (previewModal) {
        previewModal.style.display = "none";
      }
    }
  }

  handleDraw(value) {
    this.props.setLocation({
      mode: SearchModes.Listing,
      shapeDefinition: value.join('/'),
      label: '',
      stale: true,
    });
    const { toggleRange, setRange } = this.props;
    toggleRange(false)
    // Clear selectedPropertyId and selection when a new shape is drawn
    this.setState({ selectedPropertyId: null, tempRangeFrom: '', tempRangeTo: '', inputFlag: false });
    if (this.props.activeContext && this.props.activeContext.get('selectionCount') > 0) {
      this.props.toggleSelection('all', false);
    }
  }


  // handleRemoveBoundary() {
  //   const { location, setLocation } = this.props;
  //   const loc = (location || ImMap()).toJS();
  //   delete loc.shapeDefinition;
  //   setLocation({ ...loc, stale: true });
  // }

  handleChangePage(page) {
    this.props.setPage(page);
    const offset = (page - 1) * 250 + 1;
    this.setState({ resultOffset: offset, lazyDone: false, })
  }

  handleInfoWindowClose = () => {
    this.setState({ activeMarker: null });
  };

  handleChangeRange(event) {
    const { toggleRange, setRange } = this.props;
    const { name, value } = event.target || event;

    if (name === 'rangeEnabled') {
      this.setState({ activeMarker: null, lazyDone: false });
      toggleRange(value);

    } else if (name === 'rangeFrom') {
      this.setState({ tempRangeFrom: value });

    } else if (name === 'rangeTo') {
      this.setState({ tempRangeTo: value });

    } else if (name === 'filterEnable') {
      const { tempRangeFrom, tempRangeTo, activeMarker } = this.state;
      setRange(tempRangeFrom, tempRangeTo);
      this.setState({ resultOffset: tempRangeFrom ? tempRangeFrom : 1, noMoreResults: false, lazyDone: false })
      this.props.setPage(1)
      this.setState({ activeMarker: null })
    }
  }

  handleBackFromProperty = () => {
    const {
      location,
      restorePreviousResult, result
    } = this.props;
    const { storedInputFlag, selectedPropertyId } = this.state;
    this.setState({
      activeMarker: selectedPropertyId,
      inputFlag: storedInputFlag ?? this.state.inputFlag,
      storedInputFlag: null,
      waitingForApi: false,
      queriesSent: false,
      listingsReady: true,
      backBtnFlag: false,
      resetChild: true
      // selectedPropertyId: null
    });
    const shapeDef = location.get('shapeDefinition');

    const query = (location.get('query') || Map())
      .delete('propertyId')
      .delete('streetAddress')
      .delete('apn')
      .delete('fips')
      .delete('addressType')
      .toJS();
    setLocation({
      stale: false,
      backBtnFlag: false,
      query,
      shapeDef
    });
    restorePreviousResult();
  };
  handleSort({ fieldName }) {
    const { activeContext, setSort } = this.props;

    let sortField = activeContext.get('sortField');
    let sortAscending = activeContext.get('sortAscending');

    if (fieldName === sortField) {
      if (sortAscending) sortAscending = false;
      else sortField = null;
    } else {
      sortField = fieldName;
      sortAscending = true;
    }

    setSort(sortField, sortAscending);
  }

  handleLayoutChange(layout) {
    this.props.setLayout(layout);
  }

  handleOverlayChange(overlay) {
    this.props.setOverlay(overlay);
  }

  handleSaveList() {
    const { overdueAccount } = this.props.profile;
    const { planDetails } = this.props;
    const { saveListings, saveProperties, lists, openAddToMarketingListModal, leaveMessagePopup, usageSectionDetails, result, activeContext: ac, SkipTraceModal, getAppendJobEstimate, appendGroups, searchPropertyContactsByPropertyID, openInfoAlert, savedListingCount } = this.props;
    const listingMode = result.get('mode') === SearchModes.Listing;
    // openAddToGroup({
    //   selectLoading: listingMode ? selectLoading : selectPropertyLoading,
    //   groups: lists,
    //   size: ac.get('selectionCount'),
    //   limit: profile.get('marketingListAddLimit'),
    //   groupType: 'Marketing List',
    //   addPropertyMode: true,
    //   add: (name, onComplete) => {
    //     const callback = ({ response: { quantity } }) => onComplete(quantity);
    //     const sel = ac.get('selection').toJS();

    //     if (!listingMode) saveProperties(sel.map(id => [id]), name, PropertyGroupTypes.MARKETING, null, callback);
    //     else {
    //       saveListings({
    //         ...result.get('query').toJS(),
    //         resultOffset: ac.get('effectiveRangeFrom'),
    //         resultLimit: ac.get('effectiveRangeTo'),
    //       }, sel, ac.get('selectionInversed'), PropertyGroupTypes.MARKETING, name, callback);
    //     }
    //   },
    // });

    const waitForGroupId = (groups, name, maxWait = 5000) =>
      new Promise((resolve, reject) => {
        const start = Date.now();

        const check = () => {
          const groupId = groups?.find(
            g => g.name === name && g.type === "MARKETING"
          )?.id;

          if (groupId) return resolve(groupId);

          if (Date.now() - start >= maxWait)
            return reject("Timeout: groupId not found");

          setTimeout(check, 200); // retry every 200ms
        };

        check();
      });

    const selectedProperties = ac.get('displayResults').toJS()?.filter(item =>
      ac.get('selection').toJS()?.includes(item.id)
    );
    // saved and not saved count for selected items only
    const allSelectedSaved =
      selectedProperties.length === ac.get('selection').toJS()?.length &&
      selectedProperties.every(item => item.savedPropertyCount > 0);

    const selctedSavedCount =
      selectedProperties.filter(
        item => item.savedPropertyCount > 0
      ).length;

    const selctedNotSavedCount = ac.get('selection').toJS()?.length - selctedSavedCount

    // saved and not saved count for all
    const savedPropertyCount = savedListingCount || 0;
    const notSavedPropertyCount = ac.get('resultCount') - savedPropertyCount;
    const notSavedPropertyCountRangeapplied = ac.get('selectionCount') - savedPropertyCount;

    if (overdueAccount) {
      const currentPlan = planDetails && planDetails.accountEnrolledPlans && planDetails.accountEnrolledPlans.find(plan => plan.active);
      const total = currentPlan ? currentPlan.quantity : 0;
      this.props.leaveMessagePopup({
        title: "Subscription Past Due",
        message: `Your subscription is past due, and no new properties can be saved. Upgrade now to access the full ${total}.`,
        yesLable: "Upgrade",
        cancelLable: "Cancel",
        yesRedirect: () => {
          // Open the Activate Subscription popup
          this.props.openAccountUpgrade();
        },
      })
    }
    else if ((usageSectionDetails?.savesRemaining < selctedNotSavedCount && !allSelectedSaved && usageSectionDetails?.id) ||
      (ac.get('selectionInversed') && !ac.get('rangeEnabled') && usageSectionDetails?.id && usageSectionDetails?.savesRemaining < notSavedPropertyCount) ||
      (ac.get('selectionInversed') && ac.get('rangeEnabled') && usageSectionDetails?.id && usageSectionDetails?.savesRemaining < notSavedPropertyCountRangeapplied)) {
      const isTrailAccount = this.props.planDetails?.trialAvailable;
      const title = isTrailAccount ?
        "Ready to keep going?" :
        "Not Enough Save Credits";
      const message = isTrailAccount ?
        "Activate your subscription now to unlock your full property limit and continue without interruption." :
        "You don’t have enough save credits to perform this action. Please purchase additional credits to continue.";
      const yesLable = isTrailAccount ?
        "Activate Subscription" :
        "Purchase Credits";
      const yesRedirect = () => {
        if (isTrailAccount) this.props.openAccountUpgrade();
        else this.purchaseSavesAndExportsPopup();
      }
      leaveMessagePopup({
        title,
        message,
        yesLable,
        cancelLable: "Cancel",
        yesRedirect,
      })
    } else {
      openAddToMarketingListModal({
        title: 'Add to Marketing List',
        checkboxLabel: "Skip Trace Selected Properties",
        groups: lists,
        onSave: (name, onComplete, { skipTrace, isCreated }) => {
          const sel = ac.get('selection').toJS();
          let contactIdsLocal = [];
          const afterSave = ({ response: { quantity, groups, saveStartTime } }) => {

            if (!skipTrace) {
              onComplete(quantity);
              return;
            }
          
            waitForGroupId(groups, name)
              .then(groupId => {

                const payload = {
                  id: groupId,
                  allSelected: ac.get('selectionInversed'),
                  remainingSelected: ac.get('selectionInversed'),
                  selectedIds: sel,
                  unselectedIds: [],
                  recentContactsOnly: !isCreated,
                  selected: ac.get('selectionCount'),
                  filters: result.get('query').get('filters')?.toJS() || [],
                  sortModel: [],
                  saveStartTime,
                };

                const mode = "BOTH";
                const reprocessEnabled = false;

                // Resolve property -> contact ids first, then request estimate and open modal with the ids.
                searchPropertyContactsByPropertyID(payload, ({ response: contactIds }) => {
                  contactIdsLocal = contactIds || [];

                  if (contactIdsLocal && contactIdsLocal.length) {
                    getAppendJobEstimate({
                      contactIds: contactIdsLocal,
                      appendMode: mode,
                      reprocessEnabled
                    }, ({ response, error }) => {
                      onComplete(quantity);

                      if (response?.message && response?.message?.includes("There is an existing append job")) {
                        openInfoAlert({
                          title: "Skip Trace in Progress",
                          infoText: "There is a Skip Trace currently in progress. Please try again once it is complete.",
                        });
                      } else {
                        SkipTraceModal({
                          groups: appendGroups,
                          reprocessEnabled: false,
                          contactIds: contactIdsLocal,
                          selectedProperties: sel?.length,
                        });
                      }
                    });
                  } else {
                    onComplete(quantity);
                  }
                });
              })
              .catch(err => {
                console.error("Failed waiting for groupId:", err);
                onComplete(quantity);
                leaveMessagePopup({
                  title: "Error",
                  message: "Unable to retrieve associated Marketing List. Please try again.",
                  cancelLable: "Close"
                });
              });
          };


          if (!listingMode) saveProperties(sel.map(id => [id]), name, PropertyGroupTypes.MARKETING, null, afterSave);
          else {
            saveListings({
              ...result.get('query').toJS(),
              resultOffset: ac.get('effectiveRangeFrom'),
              resultLimit: ac.get('effectiveRangeTo'),
            }, sel, ac.get('selectionInversed'), PropertyGroupTypes.MARKETING, name, afterSave);
          }
        }
      });
    }
  }

  loadMarkerDetail(id, data) {
    // this.setState({ activeMarker: data ? data.get('id') : id });
    const pid = data ? data.get('id') : id;
    this.setState({
      activeMarker: pid,
      selectedPropertyId: pid,
    });
  }

  handleSelect(id, isChecked) {
    console.log("handleSelect called with id:", id, "isChecked:", isChecked);
    this.props.toggleSelection(id, isChecked);
  }

  callSavedCountListings = () => {
    const { savedCountListings, activeContext, result } = this.props;
    const { resultLimit } = this.state;
    const ac = activeContext || ImMap();
    const sortField = (ac.get('sortField') || '').trim();

    const params = {
      ...result.get('query').toJS(),
      resultOffset: ac.get('resultOffset') || 1,
      resultLimit: resultLimit || 50,
      inputRange: !!ac.get('rangeEnabled'),
      startRange: ac.get('resultOffset') || 1,
      endRange: ac.get('rangeTo') ? ac.get('rangeTo') : ac.get('resultCount') || 50,
      ...(sortField ? {
        sortField,
        sortAscending: ac.get('sortAscending') || false
      } : {})
    };

    savedCountListings(params, false);
  }


  handleReset = () => {
    this.setState({ resultOffset: 1, fetchMore: false, tempRangeFrom: '', tempRangeTo: '', lazyDone: false, activeMarker: null },
      () => {
        const { location, filter, searchListings, activeContext, searchMapPins, result } = this.props;
        const ac = activeContext || ImMap();
        const l = (location.get('query') || ImMap()).toJS();
        let filt = filter.toJS();
        const sortField = (ac.get('sortField') || '').trim();
        const shapeDef = location.get('shapeDefinition');
        this.props.setPage(1)

        filt = Object.keys(filt).reduce(
          (o, k) => ({
            ...o,
            [k]: moment.isMoment(filt[k]) ? filt[k].valueOf() : filt[k],
          }),
          {}
        );

        if (result.get('mode') !== SearchModes.Multiple) {          // listings
          searchListings({
            ...l,
            ...filt,
            type: null,
            shapeDefinition: shapeDef || undefined,
            resultOffset: 1,
            resultLimit: 50,
            ...(sortField
              ? { sortField, sortAscending: ac.get('sortAscending') || false }
              : {}),
          });

          // map pins
          searchMapPins({
            ...l,
            ...filt,
            type: null,
            shapeDefinition: shapeDef || undefined,
            resultOffset: 1,
            resultLimit: 250,
            ...(sortField
              ? { sortField, sortAscending: ac.get('sortAscending') || false }
              : {}),
          });
        }
      }
    );
  };


  loadingLock = false;

  handleLoadMore = () => {
    if (!this.state.listingsReady || this.loadingLock) return
    const { activeContext: ac, location } = this.props;
    const { resultOffset, resultLimit: defaultLimit, tempRangeTo } = this.state;
    const rangeEnabled = ac.get('rangeEnabled');
    const results = ac.get('displayResults')
    const isValidRange = Number.isFinite(tempRangeTo) && Number.isFinite(tempRangeTo);
    const pageCount = ac.get("pageCount")
    const pageIndex = ac.get("pageIndex")
    if (this.state.noMoreResults && pageCount == pageIndex) return;
    if (
      rangeEnabled
        ? ((isValidRange && tempRangeTo <= 50) || (isValidRange && resultOffset >= tempRangeTo) || results.size === 250)
        : (results.size === 250)
    ) return;
    this.loadingLock = true;
    this.setState({ fetchMore: true })
    const newOffset = resultOffset + defaultLimit;
    const remainingInRange = Math.max((tempRangeTo + 1) - newOffset, 0);
    const limit = rangeEnabled && isValidRange
      ? Math.max(0, Math.min(defaultLimit, remainingInRange))
      : defaultLimit;
    if (rangeEnabled && limit === 0 && isValidRange) {
      this.loadingLock = false;
      this.setState({ fetchMore: false })
      return;
    }
    const payload = {
      ...this.buildSearchPayload(newOffset, limit),
      ...(location && location.get('shapeDefinition') ? { shapeDefinition: location.get('shapeDefinition') } : {})
    };
    const lazyDoneNow = results.size === 200;
    const currentResultSize = results.size;
    this.props.searchListings(payload, true).finally(() => {
      this.loadingLock = false;
      const updatedResults = this.props.activeContext.get('displayResults');
      const newResultSize = updatedResults.size;
      const noNewResults = newResultSize === currentResultSize;
      this.setState({
        fetchMore: false,
        lazyDone: lazyDoneNow,
        resultOffset: newOffset,
        noMoreResults: noNewResults
      });
    });
  };

  handleSaveProperty(propertyId, _item, onSuccess) {
    const { saveProperty, openAddToGroup, favorites, result } = this.props;
    const id = propertyId || result.getIn(['property', 'id']);
    const safeSuccess = typeof onSuccess === 'function' ? onSuccess : () => { };

     const { openAddToMarketingListModal, getAppendJobEstimate, SkipTraceModal, searchPropertyContactsByPropertyID, appendGroups, usageSectionDetails, leaveMessagePopup, openInfoAlert} = this.props;

    const { overdueAccount } = this.props.profile;
      const { planDetails } = this.props;
      if(overdueAccount){
        const currentPlan  =  planDetails && planDetails.accountEnrolledPlans && planDetails.accountEnrolledPlans.find(plan => plan.active);
        const total = currentPlan ? currentPlan.quantity : 0;
        this.props.leaveMessagePopup({
            title: "Subscription Past Due",
            message: `Your subscription is past due, and no new properties can be saved. Upgrade now to access the full ${total}.`,
            yesLable: "Upgrade",
            cancelLable: "Cancel",
            yesRedirect: () => {
              // Open the Activate Subscription popup
              this.props.openAccountUpgrade();
            },
          })
      }
      else if (usageSectionDetails?.id && usageSectionDetails?.savesRemaining <= 0 ) {
        leaveMessagePopup({
          title: "Not Enough Save Credits",
          message:
            "You don’t have enough save credits to perform this action. Please purchase additional credits to continue.",
          yesLable: "Purchase Credits",
          cancelLable: "Cancel",
          yesRedirect: () => {
            // Open the Activate Subscription popup
            this.props.purchaseSavesAndExportsPopup();
          },
        })
      } else {
        openAddToMarketingListModal({
          title: 'Add to Group',
          checkboxLabel: "Skip Trace This Property",
          groups: favorites,
          onSave: (name, onComplete, { skipTrace, isCreated }) => {

            const afterSave = ({ response: { quantity, groups } }) => {

              const groupId = groups?.find(
                g => g.name === name
              )?.id;

              if (!skipTrace) {
                onComplete(quantity);
                safeSuccess();
                return;
              }

              const payload = {
                id: groupId,
                allSelected: false,
                remainingSelected: false,
                selectedIds: [propertyId],
                unselectedIds: [],
                recentContactsOnly: !isCreated,
                selected: 1,
                filters: [],
                sortModel: [],
              };

              const mode = "BOTH";
              const reprocessEnabled = false;
              searchPropertyContactsByPropertyID(payload, ({ response: contactIds }) => {
                getAppendJobEstimate({
                  contactIds,
                  appendMode: mode,
                  reprocessEnabled
                }, ({ response, error }) => {
                  onComplete(quantity);

                  if (response?.message && response?.message?.includes("There is an existing append job")) {
                    openInfoAlert({
                      title: "Skip Trace in Progress",
                      infoText: "There is a Skip Trace currently in progress. Please try again once it is complete.",
                    });
                  } else {
                    SkipTraceModal({
                      groups: appendGroups,
                      reprocessEnabled: false,
                      contactIds,
                      selectedProperties: 1,
                      isPropertySkipTrace: true,
                      onSuccess: safeSuccess,
                    });
                  }
                });
              })

            };

            saveProperty(propertyId, { name }, afterSave)
          },
        });
      }
  }

  handleRemoveBoundaryClear = () => {
    this.setState({ inputFlag: false });
    this.props.clearAll();
    this.props.clearFilter();
    this.props.clearLocalFilter();
    this.triggerReset();
  };

  handleNearbyClick = (propertyId, addressType, streetAddress, apn, cityId, backBtnFlag = false) => {
    const { inputFlag } = this.state;
    const { location } = this.props;

    this.props.savePreviousSearchState(this.props.fullReduxState)
    const shapeDefinition = location.get('shapeDefinition');
    this.setState({
      selectedPropertyId: propertyId,
      storedInputFlag: inputFlag,
      inputFlag: false
    });

    this.props.setLocation({
      mode: SearchModes.Property,
      query: {
        propertyId,
        addressType,
        streetAddress,
        apn,
        cityId
      },
      stale: true,
      backBtnFlag,
      shapeDefinition,
    });
  };

  render() {
    const {
      location,
      filter,
      result,
      activeContext,
      setOverlay,
      loading,
      refreshSearch,
      visible,
      statistic,
      setActiveContext,
      propertyLoading,
      children = null,
      selectProperty
    } = this.props;

    const { activeMarker, fetchMore } = this.state;

    const mode = result.get('mode');
    const listingMode = mode === SearchModes.Listing || mode === SearchModes.Multiple;
    const displayed = !!mode;
    const overlay = result.get('overlay');
    const property = result.get('property');

    const ac = activeContext || ImMap();
    const sortField = ac.get('sortField');
    const mapPinResult = ac.get('mapPinResult') || [];
    const selection = ac.get('selection') || List();

    const pinsForMap = fromJS(mapPinResult).map(pin => {
      const selected = selection.includes(pin.get('id'));
      return pin.set('selected', selected);
    });

    const sort = fromJS(sortField ? [sortField] : []);

    if (listingMode && !loading && !activeContext) {
      this.props.clearAll();
    }

    let mapProps;

    if (mode === SearchModes.Property || mode === SearchModes.Multiple) {
      const nearbyPins = ac.get('displayResults') || List();
      const currentId = property && property.get('id');

      let basePin =
        pinsForMap.find(p => p.get('id') === currentId)
        || nearbyPins.find(p => p.get('id') === currentId)
        || property;

      if (basePin) {
        basePin = basePin
          .set('estimatedValue',
            basePin.get('estimatedValue') ??
            property.get('estimatedValue'))
          .set('mlsListingAmount',
            basePin.get('mlsListingAmount') ??
            property.getIn(['mlsListing', 'amount']))
          .set('onMarket',
            basePin.get('onMarket') ??
            !!property.getIn(['mlsListing', 'amount']));
      }

      const currentPin = basePin ? List([basePin.set('pinColor', 'green')]) : List();


      /* put currentPin FIRST so React keeps this copy */
      mapProps = currentPin.concat(nearbyPins);
    } else {
      mapProps = pinsForMap;
    }
    const pageCount = ac.get("pageCount")
    const pageIndex = ac.get("pageIndex")
    const rangeEnabled = ac.get("rangeEnabled")
    const selectionCount = ac.get('selectionCount');

    return (
      <div style={{ display: visible ? 'block' : 'none' }}>
        <Helmet title="Search" />
        <div className={css.wrapper}>
          <Header location={location} result={result} loading={loading} setInputFlag={(val) => this.setState({ inputFlag: val })} onLayoutChange={this.handleLayoutChange} onSearch={refreshSearch} onSelect={this.handleSelect}
            onClearAll={() => {
              this.triggerReset()
            }}
          />
          <section className={classNames(css.content, { [css.contentOverlayed]: !!overlay && listingMode })}>
            <div className={classNames(mode === SearchModes.Property && css.leftSideForProperty, css.leftSide, { [css.leftSideFullSize]: !displayed })}>
              <div className={classNames(css.map, { [css.mapFullSize]: !displayed })}>
                <Map
                  properties={loading ? null : mapProps}
                  infoEnabled
                  analyticsEnabled
                  parcelClickEnabled
                  activeResult={
                    mode === SearchModes.Property
                      ? property && property.get('id')
                      : this.state.activeMarker
                  }
                  allSelected={ac.get('allSelected')}
                  onDraw={this.handleDraw}
                  onRemoveBoundary={this.handleRemoveBoundaryClear}
                  onNearbyClick={this.handleNearbyClick}
                  inputFlag={this.state.inputFlag}
                  hidePolygon={false}
                  onCloseInfoWindow={this.handleInfoWindowClose}
                  autoOpenInfo={mode !== SearchModes.Property}
                  tempRangeFrom={this.state.tempRangeFrom}
                  tempRangeTo={this.state.tempRangeTo}
                  pageCount={pageCount}
                  pageIndex={pageIndex}
                  rangeEnabled={rangeEnabled}
                  selectionCount={selectionCount}
                  reset={this.state.resetChild}
                  onResetComplete={() => this.setState({ resetChild: false })}
                />
              </div>
              {!displayed ? null : (
                <OverlayView
                  className={classNames(css.statistics, { [css.statisticsExpanded]: overlay === SearchOverlays.Graph })}
                  buttonClassName={css.bottomExpand}
                  icon="iconCaretDown"
                  iconClassName={css.iconCaret}
                  overlayType={SearchOverlays.Graph}
                  triggerOverlay={setOverlay}
                >
                  <StatisticCharts statistic={statistic} />
                </OverlayView>
              )}
            </div>
            {!displayed ? null : (
              <OverlayView
                className={classNames(mode === SearchModes.Property && css.rightSideForProperty, css.rightSide, { [css.rightSideExpanded]: overlay === SearchOverlays.Property && listingMode })}
                buttonClassName={css.rightExpand}
                icon="iconCaretDown"
                iconClassName={css.iconCaret}
                overlayType={SearchOverlays.Property}
                triggerOverlay={setOverlay}
                hideButton={mode === SearchModes.Property}
                loading={loading}
              >
                {listingMode && !loading && !this.state.waitingForApi && activeContext && (
                  <>
                    <Results
                      filter={filter}
                      result={result}
                      sort={sort}
                      activeContext={activeContext}
                      activeMarker={activeMarker}
                      onChangePage={this.handleChangePage}
                      onChangeRange={this.handleChangeRange}
                      onSort={this.handleSort}
                      onClick={this.loadMarkerDetail}
                      onSaveList={this.handleSaveList}
                      onSelect={this.handleSelect}
                      onRangeFrom={this.state.tempRangeFrom}
                      onRangeTo={this.state.tempRangeTo}
                      onReset={this.handleReset}
                      inputFlag={this.state.inputFlag}
                      setInputFlag={(val) => this.setState({ inputFlag: val })}
                      onLoadMore={this.handleLoadMore}
                      isLoading={this.state.fetchMore || this.state.waitingForApi || this.props.loading}
                      lazyDone={this.state.lazyDone}
                      scrollToPropertyId={this.state.activeMarker}
                      onSaveProperty={this.handleSaveProperty}
                      onToggleAction={() => this.callSavedCountListings()}

                    />
                    {fetchMore && (
                      <div className={css.loadingMore}>Loading more properties...</div>
                    )}
                  </>
                )}
                {mode === SearchModes.Property && !loading && (
                  <PropertyView
                    result={result}
                    activeContext={activeContext}
                    setActiveContext={setActiveContext}
                    activeMarker={activeMarker}
                    sort={sort}
                    loading={propertyLoading}
                    selectProperty={selectProperty}
                    onSort={this.handleSort}
                    onClick={this.loadMarkerDetail}
                    onSaveProperty={this.handleSaveProperty}
                    onBack={this.handleBackFromProperty}
                    backBtnFlag={this.props.backBtnFlag}
                  />
                )}
              </OverlayView>
            )}
          </section>
          <ToastNotification
            show={this.state.showToast}
            message={this.props.redirectMessage}
          />
        </div>
        {children}
      </div>
    );
  }
}

export default connect(state => ({
  stale: selectStale(state),
  location: selectLocation(state),
  suggestion: selectSuggestion(state),
  filter: selectFilter(state),
  result: selectResult(state),
  activeContext: selectActiveContext(state),
  lists: selectLists(state),
  favorites: selectOriginalFavorites(state),
  profile: selectProfile(state).toJS(),
  usageSectionDetails: selectUsageSection(state),
  statistic: selectStatistic(state),
  selectProperty: selectProperty(state),
  propertyLoading: selectPropertyLoading(state),
  loading: selectLoading(state),
  favoriteStale: selectFavoriteSearchStale(state),
  favoriteLoading: selectFavoriteSearchLoading(state),
  backBtnFlag: state.getIn(['search', 'location', 'backBtnFlag'], false),
  fullReduxState: state,
  rangeResetTick: state.getIn(['search', 'rangeResetTick'], 0),
  appendGroups: selectAppendGroups(state),
  appendJob: selectAppendJob(state).toJS(),
  redirectMessage: selectresetPasswordSuccess(state),
  planDetails: selectPlanDetails(state)?.toJS(),
  savedListingCount: state.getIn(['search', 'savedListingCount']),
}), {
  setLocation,
  clearAll,
  searchListings,
  savedCountListings,
  searchProperty,
  searchStatistics,
  searchFavorites,
  searchLeadList,
  saveListings,
  searchMapPins,
  saveProperties,
  getAppendJobEstimate,
  searchPropertyContactsByPropertyID,
  searchPropertyContacts,
  refreshSearch,
  setPage,
  toggleRange,
  toggleSelection,
  setActiveContext,
  setRange,
  setSort,
  setLayout,
  setOverlay,
  saveProperty,
  clearStatistics,
  openAddToGroup: AddToGroup.open,
  openAddToMarketingListModal: AddToMarketingListModal.open,
  confirmSaveProperty: Confirm.open,
  restorePreviousResult,
  savePreviousSearchState,
  clearPreviousSearchState,
  getPlanDetails,
  getPlansTypeAPI,
  getUsageSectionAPI,
  loadWalletList,
  getPrePaidCreditsSectionAPI,
  leaveMessagePopup: LeaveMessagePopup.open,
  SkipTraceModal: SkipTraceModal.open,
  openInfoAlert: InfoAlert.open,
  purchaseSavesAndExportsPopup: PurchaseSavesAndExportsPopup.open,
  openAccountUpgrade: ActivateSubscriptionPopup.open,
  openAddToMarketingListModal:AddToMarketingListModal.open,
  leaveMessagePopup: LeaveMessagePopup.open,
  openAccountUpgrade: ActivateSubscriptionPopup.open,
  getAppendJobEstimate,
})(deferExecutor(deferRegistrator(Search)));